<template>
  <div class="panel-body">
    <span class="text-size-20">ACROSS倉庫の商品在庫をご確認いただけます</span>
    <div id="inventory-inquiry" class="flexbox gap-15 flex-content-start" style="flex-wrap: nowrap;">
      <div class="filter">
        <form autocomplete="off" class="w-250">
          <div class="form-group">
            <label class="control-label label-normal">商品名</label>
            <input type="text" class="form-control" v-model.trim="filter.itemName">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">ASIN</label>
            <input type="text" class="form-control" v-model.trim="filter.asin">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">SKU</label>
            <input type="text" class="form-control" v-model.trim="filter.sku">
          </div>
          <div class="form-group">
            <label class="control-label label-normal">商品ラベル</label>
            <input type="text" class="form-control" v-model.trim="filter.goodsLabel">
          </div>
          <span class="control-label label-normal">在庫数</span><br>
          <div class="pd-l-10 pd-t-10">
            <div class="form-check">
              <input type="radio" name="quantity" value="" class="form-check-input" id="quantity-0"
                v-model="filter.quantity">
              <label class="form-check-label" for="quantity-0">すべて</label>
            </div>
            <div class="form-check">
              <input type="radio" name="quantity" value="IN" class="form-check-input" id="quantity-1"
                v-model="filter.quantity">
              <label class="form-check-label" for="quantity-1">在庫あり</label>
            </div>
            <div class="form-check">
              <input type="radio" name="quantity" value="OUT" class="form-check-input" id="quantity-2"
                v-model="filter.quantity">
              <label class="form-check-label" for="quantity-2">在庫切れ</label>
            </div>
          </div>
          <div class="flexbox gap-10 mr-t-10">
            <button type="button" class="btn btn-primary w-100 check-maintenance" @click="filterProducts">検索</button>
            <button type="button" class="btn w-100" @click="clearFilter">クリア</button>
          </div>
        </form>
      </div>
      <div class="items">
        <div class="flexbox justify-between">
          <span class="count">{{ displayData.length }} 件</span>
          <button type="button" class="btn btn-primary" @click="openModalDownload()">商品レポートのダウンロード</button>
        </div>
        <div class="search-table-outter">
          <table class="search-table">
            <thead>
              <tr>
                <th class="text-center">商品</th>
                <th style="min-width: 700px;"></th>
                <th class="text-right" style="min-width: 300px;">在庫数</th>
              </tr>
            </thead>
            <tbody v-if="displayData.length">
              <tr v-for="item in displayData" :key="item.itemId">
                <td class="text-center">
                  <div v-if="item.image" class="box-selected-product-image w-40">
                    <img loading="lazy" :src="item.image" alt="" class="selected-product-image img-responsive">
                  </div>
                  <div v-if="item.judgmentStatusStr" class="box-delivery-judgment-status" :class="getJudgmentStatusClass(item.judgmentStatusStr)">{{ item.judgmentStatusStr }}</div>
                </td>
                <td class="text-left">
                  <span>{{ item.itemName }}</span>
                  <br>
                  <span><b>ASIN：</b>{{ item.asin }} / <b>SKU：</b>{{ item.sku }}</span>
                  <br>
                  <span><b>商品ID：</b>{{ item.itemId }} / <b>商品ラベル：</b>{{ item.goodsLabel }}</span>
                </td>
                <td class="text-right" style="text-align: -webkit-right;">
                  <span class="text-size-24 font-bold text-primary">{{ formatNumber(item.quantity) }} </span>個
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="text-center text-danger no-data">データが見つかりません。</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <product-download
      v-if="isShowDownload"
      :warehouseType="`across`"
      @close="closeModalDownload"
      @download="handleDownloadCsv()"
    />
  </div>
</template>

<script>
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ProductDownload from '@/view/productsNew/ProductNewModalDownload'
import moment from 'moment'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ProductDownload
  },
  data () {
    return {
      filter: {
        itemName: '',
        asin: '',
        sku: '',
        goodsLabel: '',
        quantity: ''
      },
      defaultData: [],
      displayData: [],
      stocksByExpDate: {},
      isShowDownload: false
    }
  },
  created () {
    this.getInventory()
  },
  methods: {
    async getInventory () {
      this.loader = this.$loading.show()
      await WarehouseAcrossService.getInventory()
        .then((response) => {
          this.defaultData = this.displayData = response.data
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    getJudgmentStatusClass (status) {
      let statusStop = ['停止中', '削除済']
      let statusSuccess = ['出品中']
      let statusWarning = ['未審査', '審査中']
      let statusDanger = ['出品NG', '審査NG']
      if (!status) {
        return ''
      }
      if (statusSuccess.includes(status)) {
        return 'judgment-status-success'
      }
      if (statusWarning.includes(status)) {
        return 'judgment-status-warning'
      }
      if (statusDanger.includes(status)) {
        return 'judgment-status-danger'
      }
      if (statusStop.includes(status)) {
        return 'judgment-status-stop'
      }
    },
    filterProducts () {
      let logParams = {
        name: eventCode.warehouse_across.inventory_tab.click_search_btn,
        properties: {...this.filter}
      }
      EventService.postTrackLog(logParams)

      this.loader = this.$loading.show()
      setTimeout(() => {
        let products = [...this.defaultData]
        const { itemName, asin, sku, goodsLabel, quantity } = this.filter
        const hasFilter = itemName.length || asin || sku || goodsLabel || quantity
        const lower = str => str.toLowerCase()
        if (hasFilter) {
          this.displayData = products.filter((item) => {
            const matchesItemName = lower(item.itemName).includes(lower(itemName))
            const matchesAsin = lower(item.asin).includes(lower(asin))
            const matchesSku = lower(item.sku).includes(lower(sku))
            const matchesGoodsLabel = lower(item.goodsLabel).includes(lower(goodsLabel))

            if (!(matchesItemName && matchesAsin && matchesSku && matchesGoodsLabel)) return false

            if (quantity === 'IN') return item.quantity > 0
            if (quantity === 'OUT') return !item.quantity || item.quantity === 0

            return true
          })
        } else {
          this.displayData = [...this.defaultData]
        }
        this.loader && this.loader.hide()
      }, 500)
    },
    clearFilter () {
      this.filter = {
        itemName: '',
        asin: '',
        sku: '',
        goodsLabel: '',
        quantity: ''
      }
      this.displayData = [...this.defaultData]
    },
    formatNumber (number) {
      return Util.formatMoney(number)
    },
    openModalDownload () {
      this.isShowDownload = true
    },
    closeModalDownload () {
      $('#productDownload').modal('hide')
      this.isShowDownload = false
    },
    async handleDownloadCsv () {
      let logParams = {
        name: eventCode.warehouse_across.inventory_tab.click_download_csv_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      this.closeModalDownload()
      let sellerid = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `salmon_acrossProducts_${sellerid}_${reportTime}.csv`
      let params = {
        warehouseType: this.warehouseType
      }
      await WarehouseAcrossService.downloadProductCSV(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$events.fire('handleError', error)
        })
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.warehouse_across.inventory_tab.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>
<style scoped>
.panel-body {
  padding: 10px 0;
}
.control-label {
  color: #595959;
}
.filter {
  padding: 10px;
  background-color: #fff;
  border: 1px solid #ccc;
  height: auto;
  box-sizing: content-box;
}

.form-check-label {
  font-weight: unset;
}

.items {
  box-sizing: content-box;
  padding: 10px;
}

.search-table-outter {
  border: 1px solid #ccc;
  margin-top: 5px;
  overflow: hidden;
}

.search-table {
  table-layout: fixed;
}

.search-table,
td,
th {
  border-collapse: collapse;
}
td {
  border-bottom: 1px solid #ccc;
}
.search-table thead th {
  position: sticky;
  top: 0;
}

th {
  padding: 10px 5px;
  color: #595959;
  background: #deebf7;
}

td {
  padding: 5px 10px;
  height: 35px;
  background-color: #fff;
}
th,
td {
  min-width: 120px;
}
.box-selected-product-image {
  margin: 0 auto;
}
.judgment-status-not-listed {
  color: #f2f2f2;
  background-color: #a6a6a6;
}
.no-data {
  background-color: rgb(242, 222, 222);
  border-top: 1px solid #ccc;
}
.judgment-status-stop {
  background-color: #a6a6a6;
  color: #f2f2f2;
}
.judgment-status-danger {
  background-color: #c00000;
  color: #fff;
}
.text-primary {
  color:#2E75B6;
}
@media (max-width: 1440px) {
  #inventory-inquiry {
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/InventoryInquiry.vue